import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { useHasPrivilege } from '../hooks/usePermissions';

const PrivateRoute = ({ children, requiredPrivilege }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const hasPrivilege = useHasPrivilege();

  return isAuthenticated && hasPrivilege(requiredPrivilege) ? (
      children
  ) : (
      <Navigate to="/login" />
  );
};

export default PrivateRoute;
